import { useLocation, useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { clearOnLogout, getToken } from "@/lib/utils";
import { AUTH_ROUTE_PATHS } from "@/pages/Auth/authConfig";
import styles from "./Rejected.module.scss";
import RejectedIllustration from "@/components/SVGComponents/Rejected";
import LogoutIcon from "@/components/SVGComponents/LogoutIcon";

const Rejected = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const days = location.state?.days;

  const handleContactSupport = () => {
    window.location.href = "mailto:support@bfc.com";
  };

  const handleSignOut = () => {
    clearOnLogout();
    navigate(AUTH_ROUTE_PATHS.signIn);
  };

  return (
    <div className={styles.page}>
      {/* <div className={styles.logoMark}> */}
      {/* <BFCLogo width={36} height={36} /> */}
      {/* <span className={styles.logoText}>BFC</span> */}
      {/* </div> */}

      <main className={styles.main}>
        <div className={styles.card}>
          <RejectedIllustration />
          <h1 className={styles.title}>Application Not Approved</h1>
          <p className={styles.description}>
            Thank you for your interest. At the moment, we're unable to offer
            you access.
          </p>
          {
            days && <p className={styles.message}>{`Your application was rejected. You can log in after ${days} days.`}</p>
          }

          <button
            className={styles.ctaButton}
            onClick={handleContactSupport}
            type="button"
          >
            Contact Support
          </button>

          <button
            className={styles.signOutButton}
            onClick={handleSignOut}
            type="button"
          >
            {/* Sign out */}
            <LogoutIcon className={styles.logoutIcon} />
          </button>
        </div>
      </main>
    </div>
  );
};

export default Rejected;
